import {
  ConfirmResetPasswordInput,
  confirmResetPassword as amplifyConfirmResetPassword,
} from 'aws-amplify/auth';
import { useState } from 'react';
import { Utils } from 'src/utils/utils';

export const useConfirmResetPassword = () => {
  const [code, setCode] = useState<string>('');
  const [newPassword, setNewPassword] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<{
    code?: string;
    newPassword?: string;
    general?: string;
  } | null>(null);

  const confirmResetPassword = async (phoneNumber: string): Promise<void> => {
    if (!code || !newPassword) {
      setError({
        code: !code ? 'Required' : '',
        newPassword: !newPassword ? 'Required' : '',
      });
      throw Error('Reset confirmation fields are required');
    }

    try {
      setLoading(true);
      setError(null);

      const formattedPhoneNumber = Utils.formatPhone(phoneNumber);
      const input: ConfirmResetPasswordInput = {
        username: formattedPhoneNumber,
        confirmationCode: code,
        newPassword,
      };
      await amplifyConfirmResetPassword(input);
    } catch (err: any) {
      console.error('Error occurred during reset password', err);

      if (err.name === 'CodeMismatchException') {
        setError({ code: 'Invalid confirmation code' });
      } else {
        setError({ general: 'Error occurred trying to reset your password' });
      }

      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    code,
    newPassword,
    setCode,
    setNewPassword,
    confirmResetPassword,
    loading,
    error,
    setError,
  };
};
